import React, { useCallback, useEffect, useRef, useState } from 'react'
import { addCommunityForumAnswer, communityForumAnswerList, communityForumList } from '../../api/apiHandler';
import { Loading } from '../../components/loading/loading';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { CommunityForumModal } from '../../modals/communityForumModal/communityForumModal';
import { useTranslation } from 'react-i18next';
import '../../i18';
import { showErrorMessage } from '../../common/notification';

export const CommunityForum = () => {
    const { t } = useTranslation();
    const [forumList, setForumList] = useState([]);
    const [searchedForumList, setSearchedForumList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedForum, setSelectedForum] = useState(null);
    const [answerList, setAnswerList] = useState([]);
    const [submitAnswer, setSubmitAnswer] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [submitQuery, setSubmitQuery] = useState('');
    const [pageToken, setPageToken] = useState(1);
    const answerListRef = useRef(null);
    const [selectedForumPageToken, setSelectedForumPageToken] = useState(1);
    const forumRef = useRef(null);
    const [hasMounted, setHasMounted] = useState(false);

    useEffect(() => {
        if (!hasMounted) setIsLoading(true);
        const fetchData = async () => {
            try {
                await fetchForumList();
            } catch (error) {
                console.error('Error fetching Forum list:', error);
            }
            finally {
                if (!hasMounted) setIsLoading(false);
                setHasMounted(true);
            }
        };

        fetchData();
    }, [selectedForumPageToken, submitQuery]);

    const fetchForumList = useCallback(
        async () => {
            try {
                const response = await communityForumList({ limit: 10, page: selectedForumPageToken });
                if (response.code === 200 || response.code === 404) {
                    setForumList((prevForumList) => {
                        const newForums = response.data.data.filter(
                            (forum) => !prevForumList.some((f) => f.id === forum.id)
                        );
                        return [...prevForumList, ...newForums];
                    });
                    setSearchedForumList((prevForumList) => {
                        const newForums = response.data.data.filter(
                            (forum) => !prevForumList.some((f) => f.id === forum.id)
                        );
                        return [...prevForumList, ...newForums];
                    });
                    if (response.data.data?.length > 0 && selectedForumPageToken === 1) {
                        if (!selectedForum) {
                            setSelectedForum(response.data.data[0]);
                        }
                        fetchForumAnswerList();
                    }
                }
            } catch (err) {
                console.error('Error fetching forum list:', err);
            }
        }, [selectedForumPageToken]
    );

    const fetchForumAnswerList = useCallback(
        async () => {
            try {
                const response = await communityForumAnswerList({
                    community_forum_id: selectedForum?.id,
                    page: pageToken,
                    limit: 10
                });
                if (response.code === 200 || response.code === 404) {
                    setAnswerList((prevAnswerList) => {
                        const newAnswers = response.data.data.filter(
                            (answer) => !prevAnswerList.some((a) => a.id === answer.id)
                        );
                        return [...prevAnswerList, ...newAnswers];
                    });
                }
            }
            catch (err) {
                console.log('err: ', err);
            }
        }, [selectedForum, pageToken]
    );

    useEffect(() => {
        if (selectedForum && selectedForum.id) {
            setAnswerList([]);
            setPageToken(1);
            fetchForumAnswerList();
        }
    }, [selectedForum, submitAnswer]);

    // useEffect(() => {
    //     console.log("2nd useEffect");
    //     if (!hasMounted && forumList.length > 0) {
    //         const initialForum = forumList[0];
    //         setSelectedForum(initialForum);
    //         fetchForumAnswerList(); // Fetch answers for the initial forum
    //     }
    // }, [forumList, hasMounted]);

    useEffect(() => {
        if (pageToken !== 1) {
            fetchForumAnswerList();
        }
    }, [pageToken]);

    const handleAnswerSubmit = () => {
        const input = document.getElementById("answer-inp");
        const value = input.value.trim();
        if (value !== '') {
            const addAnswer = async () => {
                const response = await addCommunityForumAnswer({
                    community_forum_id: selectedForum.id,
                    answer: value
                });
                if (response.code === 200) {
                    input.value = '';
                    setSubmitAnswer(value);
                    setPageToken(1);
                }
            }
            addAnswer();
        }
        else {
            showErrorMessage(t("emptyMsgNotAllowed"))
        }
    }

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            handleAnswerSubmit();
        }
    };

    const handleSearch = (e) => {
        const value = e.target.value.trim();
        setSearchedForumList(
            forumList.filter(forum =>
                new RegExp(value, 'i').test(forum.query) ||  // Search in forum.query
                new RegExp(value, 'i').test(forum.query_user.full_name)  // Search in forum.query_user.full_name
            )
        );
    }

    function formatUTCToCustom(utcDateString) {
        return moment(utcDateString).format('ddd, D MMM [at] HH:mm');
    }

    const handleAnsScroll = (e) => {
        const isAtBottom = e.target.scrollHeight === e.target.scrollTop + e.target.clientHeight;
        if (isAtBottom) {
            setPageToken((prevToken) => prevToken + 1);
        }
    };


    const handleForumScroll = (e) => {
        const isAtBottom = e.target.scrollHeight === e.target.scrollTop + e.target.clientHeight;
        if (isAtBottom) {
            setSelectedForumPageToken((prevToken) => prevToken + 1);
        }
    }

    if (isLoading) {
        return (
            <Loading />
        )
    }

    return (
        <div className="course-single-area pd-top-120 pd-bottom-90 bgBrown">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="PageTitleBox">
                            <h2 className="PageTitleHeading">
                                {t('communityForum')}
                            </h2>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 ">
                        <div className="CommunityForumTabContentbox">
                            <div className="container">
                                <div className="row">
                                    <div className="col-xxl-4 col-xl-4 col-lg-5 col-md-6 col-sm-12 col-12 customer-left-grid m-0 ">
                                        <div className="coustomer-message-sub">
                                            <div className="coustomer-message-input">
                                                <input type="text" className="form-control coustomer-msg-input" placeholder={t("search")} onChange={handleSearch} />
                                            </div>
                                            <div className="coustomer-chat-main" id="customer-overflow-y"
                                                onScroll={handleForumScroll}
                                                ref={forumRef}
                                            >
                                                <ul className="customer-chat-ul">
                                                    {searchedForumList && searchedForumList?.length > 0 &&
                                                        searchedForumList.map((forum, index) => (
                                                            <li className="customer-chat-li p-2" key={forum?.id}>
                                                                <Link className={`coustomer-chatbot-item flex-column ${forum === selectedForum && "border-left border-success"}`} onClick={() => {
                                                                    setPageToken(1);
                                                                    setSelectedForum(forumList[index])
                                                                }}>
                                                                    <div className="PostNameBox">
                                                                        <h6 className="coustomer-chat-heading">
                                                                            {forum?.query_user?.full_name}
                                                                        </h6>
                                                                        <p className="coustomer-chat-text">
                                                                            {formatUTCToCustom(forum?.query_time)}
                                                                        </p>
                                                                    </div>
                                                                    <p className="coustomer-chat-text text-truncate-2 text-break">
                                                                        {forum?.query}
                                                                    </p>
                                                                </Link>
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xxl-8 col-xl-8 col-lg-7 col-md-6 col-sm-12 col-12 customer-right-grid m-0">
                                        <div className="coustomer-chat-person-main">
                                            <div className="coustomer-chat-person-sub">
                                                {
                                                    selectedForum && (
                                                        <>
                                                            <div className="coustomer-chat-person-header">
                                                                <div className="coustomer-chat-left align-items-center">
                                                                    <div className="coustomer-chat-avatar">
                                                                        <img src={selectedForum?.query_user?.image || process.env.PUBLIC_URL + "/assets/img/icon/default.jpg"} alt="user-img" className="coustomer-chat-user-profile" />
                                                                    </div>
                                                                    <div className="coustomer-chat-user-name">
                                                                        <h6 className="coustomer-chat-heading">
                                                                            {selectedForum?.query_user?.full_name}
                                                                        </h6>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="coustomer-chat-person-body" id="customer-overflow-y"
                                                                onScroll={handleAnsScroll}
                                                            >
                                                                <div className="ChatboatSecondBox">
                                                                    <ul className="cuatomer-right-ul">
                                                                        <li className="cuatomer-right-li">
                                                                            <div className="coustomer-chatbot-item">
                                                                                <div className="PostNameBox">
                                                                                    <h6 className="coustomer-chat-heading">
                                                                                        {selectedForum?.query_user?.full_name}
                                                                                    </h6>
                                                                                    <p className="coustomer-chat-text">
                                                                                        {formatUTCToCustom(selectedForum?.query_time)}
                                                                                    </p>
                                                                                </div>
                                                                                <p className="coustomer-chat-text">
                                                                                    {selectedForum?.query}
                                                                                </p>
                                                                            </div>
                                                                            <div className="ReaplyUserMainBox"
                                                                                ref={answerListRef}
                                                                            >
                                                                                <ul className="ReaplyUserMainBoxUl">
                                                                                    {
                                                                                        answerList && answerList?.length > 0 &&
                                                                                        answerList.map((answer) => (
                                                                                            <li className="ReaplyUserMainBoxli" key={answer?.id}>
                                                                                                <div className="coustomer-chatReplay-item text-break"
                                                                                                    style={{ backgroundColor: answer?.is_correct ? "#bae7ba" : "" }}
                                                                                                >
                                                                                                    <div className="PostNameBox">
                                                                                                        <h6 className="coustomer-chat-heading">
                                                                                                            {answer?.post_person?.full_name}
                                                                                                        </h6>
                                                                                                        <p className="coustomer-chat-text">
                                                                                                            {formatUTCToCustom(answer?.answer_time)}
                                                                                                        </p>
                                                                                                    </div>
                                                                                                    <p className="coustomer-chat-text">
                                                                                                        {answer?.answer}
                                                                                                    </p>
                                                                                                </div>
                                                                                            </li>
                                                                                        ))
                                                                                    }
                                                                                </ul>
                                                                            </div>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                            <div className="coustomer-chat-person-footer">
                                                                <div className="coustomer-chat-person-footer-left">
                                                                    <div className="input-group single-input-inner style-bg-border m-0">
                                                                        <input type="text" id={"answer-inp"} className="form-control" placeholder={t("enterFieldName", { field: t("Message") })} onKeyDown={handleKeyDown} />
                                                                        <button onClick={handleAnswerSubmit} className="input-group-text">
                                                                            <img src={process.env.PUBLIC_URL + "/assets/img/icon/SendMessageIcon.svg"} alt="apply-emoji" className="apply-emoji" />
                                                                        </button>
                                                                    </div>
                                                                    <a href="javascript:void(0)" className="chatboatIconLink" onClick={() => setIsOpen(true)}>
                                                                        <img src={process.env.PUBLIC_URL + "/assets/img/icon/postIcon.svg"} alt="chatboatIcon" className="chatboatIcon imgCover" />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <CommunityForumModal isOpen={isOpen} isClose={() => setIsOpen(false)} setSubmitQuery={setSubmitQuery}
                setPageToken={setPageToken}
                setSelectedForumPageToken={setSelectedForumPageToken}
                setSearchedForumList={setSearchedForumList} />
        </div>
    )
}
